import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(12),
    background: '#fff',
    borderRadius: spacing(8),
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    padding: spacing(12),
    border: '1px solid #e0e0e0',
    minHeight: spacing(120),
    minWidth: spacing(244),
    width: spacing(244),
    height: spacing(170),
  },
  spacedSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing(8),
  },
  shimmer: {
    background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
    backgroundSize: '200% 100%',
    animation: '$shimmerAnimation 1.5s infinite',
    borderRadius: spacing(4),
  },
  '@keyframes shimmerAnimation': {
    '0%': {
      backgroundPosition: '-200% 0',
    },
    '100%': {
      backgroundPosition: '200% 0',
    },
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(4),
  },
  idSkeleton: {
    width: spacing(60),
    height: spacing(16),
  },
  propertySkeleton: {
    width: spacing(60),
    height: spacing(16),
  },
  prioritySkeleton: {
    width: spacing(16),
    height: spacing(16),
    borderRadius: '50%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(8),
    marginBottom: spacing(8),
  },
  tenantSkeleton: {
    width: '80%',
    height: spacing(14),
  },
  categorySkeleton: {
    width: '90%',
    height: spacing(20),
  },
  addressSkeleton: {
    width: '100%',
    height: spacing(14),
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dateSkeleton: {
    width: spacing(80),
    height: spacing(14),
  },
  whatsappSkeleton: {
    width: spacing(24),
    height: spacing(24),
    borderRadius: spacing(4),
  },
  titleSkeleton: {
    height: spacing(20),
    marginBottom: spacing(4),
  },
  countSkeleton: {
    height: spacing(14),
  },
  columnHeaderWrapper: {
    padding: '8px 8px 0',
  },
  // Minimized column header skeleton styles
  minimizedColumnHeaderWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '8px 4px',
    gap: spacing(4),
  },
  minimizedButtonSkeleton: {
    width: spacing(20),
    height: spacing(20),
    borderRadius: spacing(4),
  },
  minimizedTitleSkeleton: {
    width: spacing(16),
    height: spacing(80),
    writingMode: 'vertical-rl',
    textOrientation: 'mixed',
  },
  minimizedCountSkeleton: {
    width: spacing(16),
    height: spacing(20),
    borderRadius: spacing(8),
  },
}))
